import axios from "axios";
import { Translation } from "./Translation";
import languageService from "../services/LanguageService"; 

export class TranslationApi {
    private baseUrl: string;
    public translationsCache: Array<Translation> = [];

    constructor() {
        this.baseUrl = '/api/translations';
    }
    
    public async getTranslations() : Promise<Translation[]> {
        if(this.translationsCache.length > 0)
        { 
            return this.translationsCache;
        }
    
        const isoCode = languageService.getCurrent(); // np. 'pl' lub 'pl-PL'
        let url = this.baseUrl;
        if (isoCode) {
            url += `?isoCode=${encodeURIComponent(isoCode)}`;
        }

        const result = await axios.get(url);
        this.translationsCache = Object.keys(result.data).map(x => { return {key: x, translation: result.data[x]} as Translation});
        return this.translationsCache;
    }
}

export const translationApi : TranslationApi = new TranslationApi();